import dagre from 'dagre';
import type { Edge, Node } from 'reactflow';

/**
 * Layout jerárquico vía dagre.
 *
 * La posición de cada nodo del árbol Cliente→Sucursal→Nodo no se guarda en
 * ningún lado: se recalcula en cada render a partir de la forma actual del
 * árbol (sección 4 del spec). `dagre` solo necesita el ancho/alto de cada caja
 * y las aristas; el resultado es determinista para el mismo grafo, así que no
 * hace falta memorizarlo aparte de lo que ya memoriza React.
 */

export const TOPOLOGY_NODE_WIDTH = 220;
export const TOPOLOGY_NODE_HEIGHT = 56;

export function layoutTree<T>(nodes: Node<T>[], edges: Edge[]): Node<T>[] {
  const graph = new dagre.graphlib.Graph();
  graph.setDefaultEdgeLabel(() => ({}));
  graph.setGraph({ rankdir: 'TB', nodesep: 32, ranksep: 72 });

  for (const node of nodes) {
    graph.setNode(node.id, { width: TOPOLOGY_NODE_WIDTH, height: TOPOLOGY_NODE_HEIGHT });
  }
  for (const edge of edges) {
    graph.setEdge(edge.source, edge.target);
  }

  dagre.layout(graph);

  return nodes.map((node) => {
    const { x, y } = graph.node(node.id);
    return {
      ...node,
      position: { x: x - TOPOLOGY_NODE_WIDTH / 2, y: y - TOPOLOGY_NODE_HEIGHT / 2 },
    };
  });
}
